.contentBox {
  padding: 16px;
  margin: 8px;
  border-width: 2px;
  border-style: solid;
  border-radius: var(--tuna-shape-radius-md);
  border-color: var(--tuna-palette-action-hover);
  background-color: var(--tuna-palette-action-hover);
  flex: 1 1 auto;
  min-width: 0;
}

.iconBox {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  padding: 8px;
}

.messageRow {
  width: 90%;
  align-items: center;
}

.messageRow--highlight {
  border-color: var(--tuna-palette-success-light);
  border-style: dashed;
  border-width: 2px;
}

/*
 * Assistant bubble accent (Joni §2 — surfaces agent identity on the reply
 * without touching user bubbles or body text). Pure fallback consumer — the
 * `color-mix()` itself lives in AgentChat's `.accentScope` (agent-chat.module.css),
 * which is the only place `--agent-accent-stroke`/`--agent-accent-bubble-bg`
 * get set. A comment-from-assistant rendered outside AgentChat (e.g. the
 * human Chat tool, or an @mention reply shown via SidebarChat/comments.tsx)
 * never sets these vars, so both fall through to `action-hover` here —
 * byte-identical to the base `.contentBox` rule. Accent stays
 * inline-start-only; the other three edges keep the base border on purpose.
 */
.messageRow--assistant .contentBox {
  border-inline-start: 2px solid var(--agent-accent-stroke, var(--tuna-palette-action-hover));
  background-color: var(--agent-accent-bubble-bg, var(--tuna-palette-action-hover));
}

.name {
  margin-top: 16px;
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-palette-text-secondary);
}

.timestampLeft {
  margin-left: 48px;
}

.timestampRight {
  margin-right: 48px;
}
